import type {
  Data, Variables, Cache, UpdatesConfig,
} from '@urql/exchange-graphcache';

import invalidateQuery from '../util/invalidateQuery';

const eligibilityBypassMutations: UpdatesConfig['Mutation'] = {
  eligibilityBypassCreate: (data: Data, __: Variables, cache: Cache) => {
    invalidateQuery('eligibilityBypasses', cache);
  },
  eligibilityBypassUpdate: (data: Data, __: Variables, cache: Cache) => {
    invalidateQuery('eligibilityBypasses', cache);
  },
  eligibilityBypassDelete: (data: Data, __: Variables, cache: Cache) => {
    invalidateQuery('eligibilityBypasses', cache);
  },
};

export default eligibilityBypassMutations;
